import React, { useEffect, useState, useRef } from 'react';
import SkelotonEffect from './SkelotonEffect';
import InternalBanner from './InternalBanner';
export default function SummerCamp() {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const apiKey = process.env.REACT_APP_API_KEY;

    const videoRefs = useRef([]);
    const baseURL = process.env.REACT_APP_BASE_URL;


    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const response = await fetch(`${baseURL}/my-videos-list/`, {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': apiKey
                    }
                });

                const result = await response.json();

                if (result.status === 1) {
                    setVideos(result.data);
                } else {
                    setError('Failed to fetch videos');
                }
            } catch (err) {
                setError('An error occurred while fetching videos.');
            } finally {
                setLoading(false);
            }
        };

        fetchVideos();
    }, [apiKey, baseURL]);

    const handlePlay = (index) => {
        videoRefs.current.forEach((video, i) => {
            if (video && i !== index && !video.paused) {
                video.pause();
            }
        });
    };

    if (loading) return <SkelotonEffect />;
    if (error) return (
        <section className="error-part">
            <div className="container">
                <h1 className='mb-4 d-none'>{error}</h1>
                <img className="img-fluid mb-3" src="assets/images/error.png" alt="error" />
            </div>
        </section>
    );

    return (
        <>
        <InternalBanner title="Summer Camp" />
        <section className='my-5'>
            <div className='container'>
                <div className='row'>
                    {videos.map((video, index) => (
                        <div key={video.id} className="col-md-4">
                            <div className='video_list shadow cursor-pointer' role="button">
                                <video
                                    ref={el => videoRefs.current[index] = el}
                                    poster={video.image_url}
                                    preload="none"
                                    controls
                                    className="w-100"
                                    onPlay={() => handlePlay(index)}
                                >
                                    <source src={video.video_url} type="video/mp4" />
                                </video>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
        </>
    );
}
